import { NgModule } from '@angular/core';
import { BlogTagComponent } from './blog-tag/blog-tag.component';
import { ListingComponent } from './blog-listing/listing.component';
import { BlogNavigationComponent } from './blog-navigation/blog-navigation.component';
import { BlogCategoryComponent } from './blog-category/blog-category.component';
import { InfoComponent } from './blog-info/info.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SharedModule } from '../../../shared-module/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CustomMaterialModule } from '../../../core/material.module';
import { QuillModule } from 'ngx-quill';
import { JobListingModule } from '../../../job-listing-module/job-listing.module';

export const COMPONENTS = [
  InfoComponent,
  BlogTagComponent,
  ListingComponent,
  BlogNavigationComponent,
  BlogCategoryComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    FlexLayoutModule,
    TranslateModule,
    CustomMaterialModule,
    SharedModule,
    QuillModule,
    JobListingModule,
  ],
  declarations: COMPONENTS,
  exports: COMPONENTS,
  providers: [],
  entryComponents: [],
})
export class SharedBlogModule {}
